import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { FormBuilder, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { ResidentService } from '../resident.service';
import { vovSharedService } from 'src/app/shared/services/vov-shared.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as moment from 'moment';


@Component({
  selector: 'app-parking-details',
  templateUrl: './parking-details.component.html',
  styleUrls: ['./parking-details.component.scss']
})
export class ParkingDetailsComponent implements OnInit {
  public dynamicDate: Array<any> = [1];
  parkingForm: FormGroup;
  public reasons: any;
  public streets: any;
  public states: any;
  public streetNumbers: any;
  minDate = (new Date()).toJSON();
  public maxDate: any;
  public todayDate = new Date();
  private remainingCount: any;
  public vehicleData: any;
  public otherReason: any;
  public wavierId;
  btndisabled: boolean = false;
  @ViewChild(FormGroupDirective) formGroupDirective: FormGroupDirective;
  constructor(
    private formBuilder: FormBuilder,
    private residentService: ResidentService,
    private vovSharedService: vovSharedService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private activeRouter: ActivatedRoute,
  ) { }


  ngOnInit() {
    this.parkingForm = this.formBuilder.group({
      plateNo: ['', Validators.required],
      stateId: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      reasonId: ['', Validators.required],
      otherReason: [''],
      streetId: ['', Validators.required],
      // streetNoId: ['', Validators.required],
      streetNumber: ['', Validators.required],
      // city: ['', Validators.required],
      // zipcode: ['', Validators.required]
    });
    var beginningTime = moment('6:00am', 'h:mma');
    var endTime = moment(this.todayDate, 'h:mma');
    if (!endTime.isBefore(beginningTime)) {
      const tomorrow = new Date(this.todayDate)
      tomorrow.setDate(tomorrow.getDate() + 1)
      // let date = moment(this.todayDate).add('days', 1).format('YYYY-MM-DD');
      this.todayDate = new Date(tomorrow);
    }
    //console.log(moment(new Date(restrictedTime)).format("hh:mm a").isBefore(moment(new Date(this.todayDate)).format("hh:mm a")))
    this.vovSharedService.fetchAllReasons().subscribe((res) => {
      this.reasons = res.reasons;
      this.reasons.sort((a, b) => a.reason.localeCompare(b.reason));
      //this.reasons.sort((a, b) => a.index - b.index);
      this.otherReason = this.reasons.filter(s => s.reason == 'Other')
    })

    this.vovSharedService.fetchAllStreets().subscribe((res) => {
      this.streets = res.streetsList;
      this.streets.sort((a, b) => a.street.localeCompare(b.street));
    });
    this.parkingForm.get('startDate').valueChanges.subscribe((date) => {
      if (date) {
        this.maxDate = moment(date).add(1, 'days').format('YYYY-MM-DD');
        console.log(this.maxDate, 'max date')
      }
    })
    this.vovSharedService.fetchAllStates().subscribe((res) => {
      this.states = res.statesList;
      const toSelect = this.states.sort((a, b) => a.state.localeCompare(b.state)).filter(s => s.state == 'IL')
      if (toSelect) {
        this.parkingForm.get("stateId").patchValue(toSelect[0].id);
      }
    });

    this.parkingForm.controls['streetId'].valueChanges.subscribe(
      (streetId: any) => {
        if (streetId) {
          this.vovSharedService.getStreetNumbersByStreetId(streetId).subscribe((res) => {
            this.streetNumbers = res.streetNoList;
          });
        }
      }
    );

    this.parkingForm.controls['plateNo'].valueChanges.subscribe((platNo) => { if (platNo) this.btndisabled = false });

    this.parkingForm.controls['startDate'].valueChanges.subscribe(
      (startDate: any) => {
        if (startDate) {
          this.btndisabled = false;
          const selectedStartDate = startDate;
          const tomorrow = new Date(selectedStartDate)
          tomorrow.setDate(tomorrow.getDate() + 1)
          if (tomorrow) {
            this.parkingForm.get("endDate").patchValue(tomorrow);
          }
        }
      }
    );

    this.parkingForm.controls['reasonId'].valueChanges.subscribe(
      (value) => {
        if (value == this.otherReason[0].id) {
          this.parkingForm.controls['otherReason'].setValidators([Validators.required]);
        } else {
          this.parkingForm.controls['otherReason'].setValidators([]);
          this.parkingForm.controls['otherReason'].updateValueAndValidity();
        }
        this.parkingForm.controls['otherReason'].updateValueAndValidity();
      }
    );

    // this.parkingForm.get('streetId').valueChanges.subscribe(
    //   (value) => {
    //       console.log('....',value);
    //   }
    // );


    this.activeRouter.params.subscribe(param => {
      console.log(param, 'paramm')
      this.wavierId = param.id;
      this.residentService.checkToken(param.token).subscribe(res => {
        console.log(res, 'resss')
        if (res.name == 'TokenExpiredError') {
          this.router.navigate(['error-404'])
        }
      })
    })
  }


  get streetId() {
    return this.parkingForm.get('streetId');
  }

  addDates() {
    this.dynamicDate.push(1);
  }

  onSubmit() {
    const data = {};
    console.log(this.parkingForm.value, 'valueee');
    this.btndisabled = true;
    // this.parkingForm.value['startDate'] = new Date(this.parkingForm.value['startDate']).toLocaleString();
    // this.parkingForm.value['endDate'] = new Date(this.parkingForm.value['endDate']).toLocaleString();
    const waiver_vehicle_id = localStorage.getItem("waiver_vehicle_id");
    // const waiverId = localStorage.getItem("currentWaiverId");
    this.parkingForm.value['waiver_vehicle_id'] = waiver_vehicle_id;
    this.parkingForm.value['waiverId'] = this.wavierId;
    this.residentService.submitParkingDetails(this.parkingForm.value).subscribe((res) => {
      // const currentWaiverId = localStorage.getItem("waiverId");
      data['currentWaiverId'] = this.wavierId;
      data['plateNo'] = res.plateNo;
      data['userSelectedYear'] = res.userSelectedYear;
      data['parkingId'] = res.parkingId;
      data['cycleId'] = res.cycleId;
      if (res) {
        if (res.alreadyExist) {
          const alreadyExistData = JSON.parse(localStorage.getItem('registerVehicle'));
          localStorage.setItem('registerVehicle', JSON.stringify(alreadyExistData));
        } else {
          localStorage.setItem('registerVehicle', JSON.stringify(res));
        }
        // this.router.navigate(['/waiver-summary'], res.message);
        if (res.message) {
          // this.formGroupDirective.resetForm();
          // this.parkingForm.reset();
          // this.residentService.get(res.plateNo, res.userSelectedYear,res.startDate).subscribe((response) => {
          //   // data['remainingCount'] = response.count;
          //   // // this.remainingCount = res.count;
          //   // this.vehicleData = response.vehicle.waiver_vehicle[0].vehicle_details;
          //   // this.vehicleData.forEach(element => {
          //   //   element['plateNo'] = response.vehicle.plateNo;
          //   //   element['state'] = response.vehicle.states.state;
          //   // });
          //   // data['parkingData'] = this.vehicleData;
          // });
          if (res.message == 'Already Exist Permit') {
            this._snackBar.open('This license plate has a valid overnight parking permit.', '', {
              duration: 3000,
              horizontalPosition: 'right',
              panelClass: 'warning-snackbar'
            });
            return;
          }
          if (res.message == 'Year cycle not been added,Please contact administrator.') {
            this._snackBar.open(res.message, '', {
              duration: 3000,
              horizontalPosition: 'right',
              panelClass: 'warning-snackbar'
            });
            return;
          }

          if (res.message == 'Already Exist') {
            this._snackBar.open('A waiver has already been approved for this license plate on this date.', '', {
              duration: 5000,
              horizontalPosition: 'right',
              panelClass: 'warning-snackbar'
            });
          } else {
            if (res.message == 'WAIVER REQUEST APPROVED') {
              this.residentService.sendApprovedMail(data).subscribe((res) => {
              });
              this._snackBar.open('Approved: Please check your email for details.', '', {
                duration: 5000,
                horizontalPosition: 'right',
                panelClass: 'success-snackbar'
              });
            } else {
              this.residentService.sendNotApprovedMail(data).subscribe((res) => {

              });
              this._snackBar.open('Not Approved: Please check your email for details.', '', {
                duration: 5000,
                horizontalPosition: 'right',
                panelClass: 'warning-snackbar'
              });
            }
            // const navigationExtras: NavigationExtras = {state: {data: res.message}};
            this.router.navigate(['/waiver-summary']);
            // this.router.navigate(['/waiver-summary', { message: res.message, plateNo: res.plateNo, userSelectedYear: res.userSelectedYear, parkingId: res.parkingId,startDate: res.startDate, si: true }]);
          }
          //  console.log(res); 
          //  this._snackBar.open('Success :' + res.message, '', {
          //   duration: 3000,
          //   horizontalPosition: 'right',
          //   panelClass: 'success-snackbar'
          // });  

        }
      }
    }, error => {
      let errorMessage = error.error.message ? error.error.message : error;
      if (errorMessage == 'Year cycle not been added,Please contact administrator.') {
        this._snackBar.open('Error :' + errorMessage, '', {
          duration: 3000,
          horizontalPosition: 'right',
          panelClass: 'error-snackbar'
        });
      }
      this._snackBar.open('Error :' + errorMessage, '', {
        duration: 3000,
        horizontalPosition: 'right',
        panelClass: 'error-snackbar'
      });
    });
  }

} 
